import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

export interface LocalImageProps {
  src: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  onClick?: () => void;
}

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  width: 30px;
  height: 30px;

  &::after {
    content: '';
    width: 25px;
    height: 25px;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top-color: #1890ff; /* 可以根据你的主题颜色调整 */
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #eee;
`;

export default function LocalImage({
  src,
  width = 500,
  height = 500,
  alt,
  style,
  className,
  onClick,
  imageStyle,
}: LocalImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const proxiedSrc = `/n-api/image-proxy?url=${encodeURIComponent(src)}`;

  useEffect(() => {
    setIsLoading(true);
  }, [src]);

  const defaultImageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    minWidth: '20px',
    minHeight: '20px',
  };

  const mergedImageStyle = { ...defaultImageStyle, ...imageStyle };

  return (
    <ImageWrapper style={style} className={className} onClick={onClick}>
      {isLoading && <LoadingSpinner />}
      <Image
        style={mergedImageStyle}
        width={width}
        height={height}
        src={proxiedSrc}
        alt={alt ?? 'Dolphinradar Image'}
        loading="lazy"
        onLoadingComplete={() => setIsLoading(false)}
        key={proxiedSrc}
      />
    </ImageWrapper>
  );
}
